import React, { useState } from "react";
import { Button, message } from "antd";
import { Editor } from "@tinymce/tinymce-react";
import ScaledHtmlPreview from "../../../ui/ScaledHtmlPreview";
import FormHistoryCards from "./FormHistoryCards";
import { FORM_EDITOR_INIT } from "./tinymceConfig";
import { mergeIntoDocument } from "./formDocumentHtml";
import "./FormDocument.css";


const FormDocumentView = ({
  html,
  history = [],
  designWidth = 900,
  canEdit = false,
  onSave,
  onShare,
  extraActions = null,
  leading = null,
}) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const startEditing = () => {
    setValue(html || "");
    setEditing(true);
  };

  const cancelEditing = () => {
    setValue(html || "");
    setEditing(false);
  };

  const saveDocument = async () => {
    if (!onSave) return false;
    setSaving(true);
    try {
      // Put the edited body back into the original page so the stylesheet in
      // its <head> survives the save.
      const saved = await onSave(mergeIntoDocument(html, value));
      if (saved) setEditing(false);
      return saved;
    } catch (err) {
      console.error(err);
      message.error(
        err?.response?.data?.message || "Failed to save. Please try again."
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  const hasActions =
    Boolean(extraActions) || canEdit || Boolean(onShare) || Boolean(leading);

  return (
    <>
      {!editing && (hasActions || history.length > 0) && (
        <div className="ds-history-row">
          {leading}
          <FormHistoryCards entries={history} />
          {hasActions && (
            <div className="ds-history-row__actions">
              {extraActions}
              {canEdit && (
                <Button className="ds-btn ds-btn--ghost" onClick={startEditing}>
                  Edit
                </Button>
              )}
              {onShare && (
                <Button
                  className="ds-btn ds-btn--primary"
                  onClick={() => onShare(null)}
                >
                  Share
                </Button>
              )}
            </div>
          )}
        </div>
      )}

      {editing ? (
        <>
          <Editor
            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
            init={FORM_EDITOR_INIT}
            initialValue={html || ""}
            onEditorChange={(content) => setValue(content)}
          />
          <div className="ds-edit-footer">
            <Button
              className="ds-btn ds-btn--ghost"
              onClick={cancelEditing}
              disabled={saving}
            >
              Cancel
            </Button>
            <Button
              className="ds-btn ds-btn--ghost"
              onClick={saveDocument}
              loading={saving}
            >
              Save
            </Button>
            {onShare && (
              <Button
                className="ds-btn ds-btn--primary ds-btn--wide"
                onClick={() =>
                  onShare(mergeIntoDocument(html, value), () =>
                    setEditing(false)
                  )
                }
                disabled={saving}
              >
                Save &amp; Share
              </Button>
            )}
          </div>
        </>
      ) : (
        <ScaledHtmlPreview
          html={html}
          designWidth={designWidth}
          className="ip-form-html-preview"
        />
      )}
    </>
  );
};

export default FormDocumentView;
